
import { createUseStyles } from "react-jss";

const AFAPortfolioListStyles = createUseStyles({
    dataTableWrap: {
        margin: "0",
        '& table > thead > tr > th.MuiTableCell-head': {
            color: '#000000',
            fontWeight: 'bold'
        },
        '& table > thead > tr > th.MuiTableCell-head button': {
            color: '#000000',
            fontWeight: 'bold'
        },
        '& .MuiToolbar-root': {
            display: "none"
        },
    },
});

export default AFAPortfolioListStyles;